import {
  IonCol,
  IonContent,
  IonGrid,
  IonIcon,
  IonPage,
  IonRow,
} from '@ionic/react';
import { useParams } from 'react-router';
import { Crate } from '../../../components/crates/crate/Crate';
import { useIcons } from '../../../hooks/useIcons';
import crateStyle from '../../create-crate/create-crate.module.scss';

export default function GenerateCrate() {
  const { buildType } = useParams<{ buildType: string }>();
  const { crateId } = useParams<{ crateId: string }>();
  const { icons } = useIcons();
  // const selectedCrate = useSelector(selectSelectedCrate);

  return (
    <IonPage id="crate-page">
      <IonContent fullscreen className="crate-page-content">
        <Crate id={crateId} withTracks={true} />
      </IonContent>
    </IonPage>
  );
}
